type ChipOption<T extends string | number> = {
  label: string;
  value: T;
};

type SettingsChipGroupProps<T extends string | number> = {
  options: ChipOption<T>[];
  value: T;
  disabled?: boolean;
  onChange: (value: T) => void;
};

/** Design HTML `chip()` group used across Settings rows. */
export function SettingsChipGroup<T extends string | number>({
  options,
  value,
  disabled = false,
  onChange,
}: SettingsChipGroupProps<T>) {
  return (
    <span className="flex flex-wrap gap-2">
      {options.map((option) => {
        const on = option.value === value;
        return (
          <button
            key={String(option.value)}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className="rounded-[9px] px-[15px] py-[9px] text-[13.5px] font-semibold disabled:opacity-50"
            style={{
              color: on ? 'var(--gs-ink)' : 'var(--gs-muted)',
              background: on ? 'var(--gs-panel2)' : 'transparent',
              border: `1px solid ${on ? 'var(--gs-accent)' : 'var(--gs-line)'}`,
              fontFamily: 'inherit',
              cursor: disabled ? 'default' : 'pointer',
            }}
          >
            {option.label}
          </button>
        );
      })}
    </span>
  );
}
